<script lang="ts">

  import { Button } from "$lib/components/ui/button"
  import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "$lib/components/ui/sheet"
  import { useDialog } from "$lib/hooks/use-dialog.svelte"
  import XIcon from "@lucide/svelte/icons/x"

  const dialog = useDialog()
  let url = $state("")

  $effect(() => {

    function handleView(event: CustomEvent) {
      url = event.detail as string
      dialog.setOpen(true)
    }

    window.addEventListener("view-doc", handleView as EventListener)
    return () => {
      window.removeEventListener("view-doc", handleView as EventListener)
    }
  })

</script>
<Sheet
  open={dialog.state}
  onOpenChange={dialog.setOpen}
  onOpenChangeComplete={() => ""}>
  <SheetContent
    class="h-full! w-full! z-60 p-0 border-none data-[state=open]:duration-0"
    side="bottom"
    showCloseButton={false}>
    <SheetHeader class="hidden">
      <SheetTitle>View PDF</SheetTitle>
      <SheetDescription></SheetDescription>
    </SheetHeader>
    <div class="flex h-full flex-col">
      <nav class="sticky w-full top-0 border-b bg-background">
        <div class="flex h-12 items-center justify-between px-3">
          <div class="flex items-center gap-2">
            <Button variant="ghost"
                    size="icon"
                    class="rounded-full"
                    onclick={() => dialog.setOpen(false)}>
              <XIcon/>
            </Button>
            <h1 class="text-lg font-medium">
              Lihat Dokumen
            </h1>
          </div>
          <div>
          </div>
        </div>
      </nav>
      <iframe src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURI(url)}`}
              class="flex-1 border-none"
              title="Lihat Dokumen"></iframe>
    </div>
  </SheetContent>
</Sheet>
